import React from 'react';
import Screenshot from '../../../img/Course-Elements/Screenshot.jpg';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import DigitalMarketing2 from '../../../img/Course-Elements/DigitalMarketing2.png'
import CourseOperate from '../../Shared/Courses/CourseOperate';

const DigitalMarketing = () => {
    
        
        return (
            <div className='px-4 md:px-12 pt-10'>
                <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
                <h1 className='text-blue-500 text-5xl font-semibold my-4'>Digital <span className='text-orange-400'>Marketing</span></h1>
                <h1 className='text-4xl font-semibold my-4'>Course @ Rs. 1199</h1>
                <h2 className=''>Learn Google Analytics, Google Ads, SEO, social media marketing,
                email marketing, and more to become a pro at digital marketing.</h2>
                <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
                <h5>Offer: Get flat Rs.200 off by applying the promo code CAREERHikers</h5>
                <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
                <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
                <CourseHighlights />
                <div className='flex mb-8 mt-12'>
                    <div className='flex-1 md:mr-4'>
                        <h1 className='text-3xl font-semibold mb-6'>Why Learn Digital Marketing?</h1>
                        <h2 className='text-2xl my-2'>Publish your concept to the masses</h2>
                        <p>Digital marketing may help you reach millions, regardless of whether you want
                    to handle PR for your college festival or have an app, blog, or YouTube channel.</p>
                        <h1 className='text-2xl my-2'>Be in demand</h1>
                        <h3>With hundreds of internships and positions offered every day,
                    digital marketing is one of the trendiest professional paths today.</h3>
                        <h1 className='text-2xl my-2'>Use your imagination</h1>
                        <p>Whether you enjoy words, figures, or visual arts, digital marketing
                    provides a heady brew of creativity for everybody.</p>
                    </div>
                    <img className='flex-1' src={DigitalMarketing2} alt="" />
                </div>
                <CourseOperate />
            </div>
        );
};

export default DigitalMarketing;